import { create } from 'zustand';
import React from 'react';

export interface TopBarConfig {
  title?: string;
  subtitle?: string;
  showLogo?: boolean;
  hideDefaultActions?: boolean;
  actions?: React.ReactNode;
  showBack?: boolean;
  backTo?: string;
  onBack?: () => void;
  backLabel?: string;
  editableTitle?: { value: string; maxLength?: number; onChange: (value: string) => void; onBlur?: () => void };
}

interface TopBarState extends TopBarConfig {
  setTopBarConfig: (config: TopBarConfig) => void;
  resetTopBarConfig: () => void;
}

const defaultConfig: TopBarConfig = {
  title: undefined,
  subtitle: undefined,
  showLogo: true,
  hideDefaultActions: false,
  actions: null,
  showBack: false,
  backTo: undefined,
  onBack: undefined,
  backLabel: undefined,
  editableTitle: undefined
};

export const useTopBarStore = create<TopBarState>((set) => ({
  ...defaultConfig,
  setTopBarConfig: (config) => set((state) => ({ ...state, ...config })),
  resetTopBarConfig: () => set(defaultConfig)
}));
